var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortingArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16663 4.83333L4.12619 2.87377C4.51671 2.48325 5.14987 2.48325 5.5404 2.87377L7.49996 4.83333M8.49996 11.1667L10.4595 13.1262C10.85 13.5167 11.4832 13.5167 11.8738 13.1262L13.8333 11.1667M4.83329 3.33333V13.5M11.1666 2.5V12.8333",
    stroke: "#282829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingArrow);
export default __webpack_public_path__ + "static/media/SortingArrow.10a0f23bc24cfd105977dd15f02d4876.svg";
export { ForwardRef as ReactComponent };